import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import ImageWithBasePath from "../imageWithBasePath";
import { all_routes } from "../../../feature-module/router/all_routes";
import { useDispatch, useSelector } from "react-redux";
import {
  setExpandMenu,
  setMiniSidebar,
  setMobileSidebar,
} from "../../data/redux/commonSlice";
import { logout } from "../../data/redux/authSlice";
import { RootState } from "../../data/redux/store";
import { useGetAllLeadsQuery } from "../../data/redux/apis/leadService";
const Header = () => {
  const route = all_routes;
  const location = useLocation();
  const dispatch = useDispatch();
  const mobileSidebar = useSelector((state: any) => state.mobileSidebar);
  const miniSidebar = useSelector((state: any) => state.miniSidebar);
  const navigate = useNavigate();
  const loggedUser = useSelector((state: RootState) => state.auth.user);
  const { data: leads } = useGetAllLeadsQuery({});

  const leadData =
    leads?.data.filter((lead: any) => lead.userId === loggedUser?.userId) || [];

  const count = leadData.length;

  const toggleMobileSidebar = () => {
    dispatch(setMobileSidebar(!mobileSidebar));
  };
  const toggleMiniSidebar = () => {
    dispatch(setMiniSidebar(!miniSidebar));
  };
  const toggleExpandMenu = () => {
    dispatch(setExpandMenu(true));
  };
  const toggleExpandMenu2 = () => {
    dispatch(setExpandMenu(false));
  };

  const getInitials = (fullName: string | null | undefined) => {
    if (!fullName) return ""; // Return empty string if fullName is null or undefined
    const nameParts = fullName.split(" ");
    const initials = nameParts[0][0] + (nameParts[1] ? nameParts[1][0] : "");
    return initials.toUpperCase();
  };

  const [layoutBs, setLayoutBs] = useState(localStorage.getItem("dataTheme"));
  const isLockScreen = location.pathname === "/lock-screen";

  if (isLockScreen) {
    return null;
  }
  const LayoutDark = () => {
    localStorage.setItem("dataTheme", "dark");
    document.documentElement.setAttribute("data-theme", "dark");
    setLayoutBs("dark");
  };
  const LayoutLight = () => {
    localStorage.setItem("dataTheme", "light");
    document.documentElement.setAttribute("data-theme", "light");
    setLayoutBs("light");
  };

  const handleLogout = () => {
    // Dispatch the logout action
    dispatch(logout());

    // Redirect to the login page
    navigate("/login"); // Or use your login route here
  };

  return (
    <>
      {/* Header */}
      <div
        className="card-body header sticky-top"
        style={{
          boxShadow: "4px 4px 10px rgba(0, 0, 0, 0.2)", // Shadow on the right and bottom
          borderRadius: "8px", // Optional for rounded corners
        }}
      >
        <div className="">
          {/* Logo */}
          <div
            className="header-left active"
            onMouseEnter={toggleExpandMenu}
            onMouseLeave={toggleExpandMenu2}
          >
            <Link
              to={route.dashboard}
              style={{ display: "flex", alignItems: "center" }}
            >
              <div className="d-flex flex-column justify-content-center align-items-center">
                <ImageWithBasePath
                  src="assets/img/logoPremier.png"
                  alt="Logo"
                  className="header-logo"
                />
                <span
                  className="fw-bold text-muted m-0"
                  style={{ fontSize: "10px" }}
                >
                  Powered By: Zyonix System
                </span>
              </div>
            </Link>

            {/* <Link to={route.dashboard} className="logo-small">
              <ImageWithBasePath src="assets/img/logo-small.svg" alt="Logo" />
            </Link> */}
            {/* <Link id="toggle_btn" to="#" onClick={toggleMiniSidebar}>
            <i className="ti ti-arrow-bar-to-left" />
          </Link> */}
          </div>
          {/* /Logo */}
          <Link
            id="mobile_btn"
            className="mobile_btn"
            to="#sidebar"
            onClick={toggleMobileSidebar}
          ></Link>
          <div className="header-user mt-3">
            <ul className="nav user-menu">
              {/* Search */}
              <li className="nav-item nav-search-inputs me-auto">
                {/* <div className="top-nav-search">
                <Link to="#" className="responsive-search">
                  <i className="fa fa-search" />
                </Link>
                <form className="dropdown">
                  <div className="searchinputs" id="dropdownMenuClickable">
                    <input type="text" placeholder="Search" />
                    <div className="search-addon">
                      <button type="submit">
                        <i className="ti ti-command" />
                      </button>
                    </div>
                  </div>
                </form>
              </div> */}
              </li>
              {/* /Search */}
              {/* Nav List */}
              <li className="nav-item nav-list">
                <ul className="nav">
                  <li className="dark-mode-list">
                    <Link
                      to="#"
                      className={`dark-mode-toggle ${layoutBs ? "" : "active"}`}
                      id="dark-mode-toggle"
                    >
                      <i
                        className={`ti ti-sun light-mode ${
                          layoutBs === "dark" ? "" : "active"
                        }`}
                        onClick={LayoutLight}
                      >
                        {" "}
                      </i>
                      <i
                        className={`ti ti-moon dark-mode ${
                          layoutBs === "dark" ? "active" : ""
                        }`}
                        onClick={LayoutDark}
                      ></i>
                    </Link>
                  </li>
                </ul>
              </li>
              {/* /Nav List */}
              {/* Email */}
              <li className="nav-item nav-item-email nav-item-box">
                <Link to={route.chat}>
                  <i className="ti ti-message-circle-exclamation" />
                  <span className="badge rounded-pill">{count}</span>
                </Link>
              </li>
              {/* /Email */}
              {/* Profile Dropdown */}
              <li className="nav-item dropdown has-arrow main-drop ">
                <Link
                  to="#"
                  className="nav-link userset"
                  data-bs-toggle="dropdown"
                >
                  <span className="user-info px-2">
                    <span className="user-letter">
                      {/* <ImageWithBasePath
                        src="assets/img/profiles/user-avatar.png"
                        alt="Profile"
                      /> */}
                      <p className="my-0 fw-bold text-dark rounded-circle border px-2 py-1 bg-soft-primary">
                        {getInitials(loggedUser?.userFullName)}
                      </p>
                    </span>
                  </span>
                  <div className="mx-2">
                    <p className="my-0 fw-bold">{loggedUser?.userFullName}</p>
                    <p className="my-0">{loggedUser?.userRoleName}</p>
                  </div>
                </Link>
                <div className={` dropdown-menu  menu-drop-user `}>
                  <div className="profilename">
                    {/* <Link className="dropdown-item" to={route.profile}>
                    <i className="ti ti-user-pin" /> My Profile
                  </Link> */}
                    <Link
                      className="dropdown-item"
                      onClick={handleLogout}
                      to={route.login}
                    >
                      <i className="ti ti-lock" /> Logout
                    </Link>
                  </div>
                </div>
              </li>
              {/* /Profile Dropdown */}
            </ul>
          </div>
          {/* Mobile Menu */}
          <div className="dropdown mobile-user-menu">
            <Link
              to="#"
              className="nav-link dropdown-toggle"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <i className="fa fa-ellipsis-v" />
            </Link>
            <div className={` dropdown-menu `}>
              <Link className="dropdown-item" to={route.dashboard}>
                <i className="ti ti-layout-2" /> Dashboard
              </Link>
              <Link className="dropdown-item" to={route.login}>
                <i className="ti ti-lock" /> Logout
              </Link>
            </div>
          </div>
          {/* /Mobile Menu */}
        </div>
      </div>
    </>
  );
};

export default Header;
